import { render, staticRenderFns } from "./icon-x.vue?vue&type=template&id=08c1d58a&scoped=true"
import script from "./icon-x.vue?vue&type=script&lang=js"
export * from "./icon-x.vue?vue&type=script&lang=js"
import style0 from "./icon-x.vue?vue&type=style&index=0&id=08c1d58a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1d58a",
  null
  
)

export default component.exports